import FormControlLabel from '@mui/material/FormControlLabel'
import MenuItem from '@mui/material/MenuItem'
import Radio from '@mui/material/Radio'
import { styled } from '@mui/material/styles'
import { isNil } from 'ramda'
import React from 'react'

type Option = {
  label: string
  value: string
}

type Props = {
  name: string
  options: Option[]
  value: string
  onChange: (value: string) => void
}

const SingleChoice = React.forwardRef<HTMLDivElement, Props>(({ name, options, value, onChange }, ref) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value)
    },
    [onChange],
  )

  React.useEffect(() => {
    if (isNil(value) && options.length) {
      onChange(options[0].value)
    }
  }, [options, value, onChange])

  return (
    <div data-testid={`single-choice-${name}`} ref={ref}>
      {options &&
        options.map((option) => (
          <MenuItem disableGutters key={option.value} sx={{ p: 0 }} value={option.value}>
            <ChoiceLabel
              control={
                <Radio checked={value === option.value} name={name} value={option.value} onChange={handleChange} />
              }
              label={option.label}
            />
          </MenuItem>
        ))}
    </div>
  )
})

const ChoiceLabel = styled(FormControlLabel)({
  margin: 0,
  padding: '6px 16px 6px 5px',
  width: '100%',
})

export default SingleChoice
